// Avatar data with actual working image URLs
export const avatarStyles = [
  {
    id: 1,
    name: 'Professional Male',
    url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=professional-male&style=circle&backgroundColor=b6e3f4',
    category: 'Professional',
    gender: 'Male',
    features: ['Suit', 'Formal', 'Business']
  },
  {
    id: 2,
    name: 'Professional Female',
    url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=professional-female&style=circle&backgroundColor=ffdfbf',
    category: 'Professional',
    gender: 'Female',
    features: ['Business Attire', 'Formal', 'Professional']
  },
  {
    id: 3,
    name: 'Creative Male',
    url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=creative-male&style=circle&backgroundColor=c0aede',
    category: 'Creative',
    gender: 'Male',
    features: ['Artistic', 'Casual', 'Modern']
  },
  {
    id: 4,
    name: 'Creative Female',
    url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=creative-female&style=circle&backgroundColor=ffd5dc',
    category: 'Creative',
    gender: 'Female',
    features: ['Artistic', 'Stylish', 'Modern']
  },
  {
    id: 5,
    name: 'Casual Male',
    url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=casual-male&style=circle&backgroundColor=b6e3f4',
    category: 'Casual',
    gender: 'Male',
    features: ['Relaxed', 'Everyday', 'Comfortable']
  },
  {
    id: 6,
    name: 'Casual Female',
    url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=casual-female&style=circle&backgroundColor=ffdfbf',
    category: 'Casual',
    gender: 'Female',
    features: ['Relaxed', 'Everyday', 'Comfortable']
  },
  {
    id: 7,
    name: 'Tech Male',
    url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=tech-male&style=circle&backgroundColor=c0aede',
    category: 'Tech',
    gender: 'Male',
    features: ['Modern', 'Digital', 'Tech-savvy']
  },
  {
    id: 8,
    name: 'Tech Female',
    url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=tech-female&style=circle&backgroundColor=ffd5dc',
    category: 'Tech',
    gender: 'Female',
    features: ['Modern', 'Digital', 'Tech-savvy']
  }
];

export const avatarCategories = [
  'Professional',
  'Creative',
  'Casual',
  'Tech'
];

export const avatarFeatures = [
  'Suit',
  'Formal',
  'Business',
  'Business Attire',
  'Professional',
  'Artistic',
  'Casual',
  'Modern',
  'Stylish',
  'Relaxed',
  'Everyday',
  'Comfortable',
  'Digital',
  'Tech-savvy'
]; 